import { useRef, useState } from 'react';
import { uploadFile } from '../../lib/storage';

export default function GalleryUploader({ images = [], onAdd, onDelete }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (file) => {
    if (!file?.type.startsWith('image/')) return;
    setUploading(true);
    try {
      const url = await uploadFile('news-media', 'gallery', file);
      onAdd(url);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-brand-dark">Gallery images</label>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {images.map((img) => (
          <div key={img.id} className="relative group rounded-lg overflow-hidden border border-gray-200">
            <img src={img.image_url} alt="" className="w-full h-28 object-cover" />
            <button
              type="button"
              onClick={() => onDelete(img.id)}
              className="absolute top-1 right-1 bg-red-600 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity"
            >
              Remove
            </button>
          </div>
        ))}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={(e) => handleFile(e.target.files?.[0])}
      />
      <button
        type="button"
        disabled={uploading}
        onClick={() => inputRef.current?.click()}
        className="text-sm px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
      >
        {uploading ? 'Uploading…' : '+ Add gallery image'}
      </button>
    </div>
  );
}
